export default __webpack_public_path__ + "4403838c26aa2155eb84aaa939883c2a.woff2";